export const CURSORS = {
  default: {
    isIcon:false,
    iconPath:'',
    size: 16,
    background: "",
    color: "#000",
    text: "",
    borderRadius: "50%",
    blendMode: "normal",
    border: "1px solid #000",
    lerp: 0.2,
  },
  hero: {
    isIcon:false,
    iconPath:'',
    size: 24,
    background: "#ffffff",
    color: "#fff",
    text: "",
    borderRadius: "50%",
    blendMode: "difference",
    border: "1px solid #fff",
    lerp: 0.15,
  },
  project: {
    isIcon:false,
    iconPath:'',
    size: 90,
    background: "#000",
    color: "#fff",
    text: "VIEW",
    borderRadius: "50%",
    blendMode: "normal",
    border: "none",
    lerp: 0.18,
  },
  image: {
    isIcon:false,
    iconPath:'',
    size: 70,
    background: "#fff",
    color: "#000",
    text: "",
    borderRadius: "12px",
    blendMode: "normal",
    border: "none",
    lerp: 0.18,
  },
  contact: {
    isIcon:false,
    iconPath:'',
    size: 80,
    background: "#000",
    color: "#fff",
    text: "SAY HI",
    borderRadius: "50%",
    blendMode: "normal",
    border: "none",
    lerp: 0.18,
  },
  icon:{
    isIcon:true,
    iconPath:'',
    size: 80,
    background:"",
    color: "",
    text: "",
    borderRadius: "50%",
    blendMode: "normal",
    border: "none",
    lerp: 0.18,
  }
}